import React, { useState, useEffect } from 'react';
import SwiperComponent from "../common/swipers";
import CardsComponent from "../common/cards";
import AccordionComponent from "../common/accordion";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { json, Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BottomModal1Component from './bottom-modal1';
import NojoomPointsHistory from '../nojoom-comp/nojoom-points-history';
import DatePickerToFrom from './date-picker';
import TransferCreditPay from '../../pages/transfer-credit/transfer-credit-pay';
import NoData from '../common/no-data';
import { Swiper, SwiperSlide } from "swiper/react";
import { redirecturl } from '../../services/common/redirect';
import {
    isContainAlphabet, 
    getItemOfSessionStorage
  } from "../../services/common/utils";
import { SELECTED_LANG } from "../../services/common/Constants";
import { Grid, Pagination } from 'swiper';
import BottomModalRoamingInterRates from './bottom-modal-roaming-interRates';
import { getGlobalSettingValue } from '../../services/common/utils';
import ExclusiveModal from './exclusive-modal';

const TabsComponent = ({ type, data, state, categories, isViewPacks=false, isNoFilterItem, giftnumber , metaData={}}) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const customerprofile = useSelector(
        (state) => state.userdata.value.customerprofile
    );
    const lang = getItemOfSessionStorage(SELECTED_LANG);
    const [showModal, setShowModal] = useState(false);
    const [show, setShow] = useState(false);
    const [displaytext, setDisplayText] = useState();
    const [roamingCheckBox, setroamingCheckBox] = useState(data?.basicServices && data?.basicServices[0].status === "A")
    const [callsCheckBox, setCallsCheckBox] = useState(data?.basicServices && data?.basicServices[1].status === "A")
    const [roaming_CheckBox, setroaming_CheckBox] = useState(data?.roaming && data?.roaming[0]?.status === "A")
    const [calls_CheckBox, setCalls_CheckBox] = useState(data?.international && data?.international[0]?.status === "A")
    const [flag, setFlag] = useState("Roaming")
    const toggleModal = () => {
        setShowModal(!showModal);
    };
    const language = getItemOfSessionStorage(SELECTED_LANG);
    const [key, setKey] = useState('all');
    const location = useLocation();
    const {
        utilityData: {
          globalSetting,
        }
      } = useSelector((state) => state);
    const settingsArr = globalSetting
      ? globalSetting?.Globalsettings[0]?.items[0]?.metadata : [];
      
    if (type === 1) {
        //console.log(data, "datasss")
        return ((data?.length > 0) ? <Tabs activeKey={(data?.length === 1) ? data[0]?.id : key}
        onSelect={(k) => setKey(k)} id="uncontrolled-tab-example" className="cs_tabs">
            {/* All */}
            {/* {console.log(filteredCategory, "filteredCategoryfilteredCategory")} */}
            {((state !== null && state?.length === 0 || state?.length > 1) && data?.length > 1) &&
                <Tab eventKey="all" title={t('All')}>
                    <div className='mt-5'>
                        {data?.map(res => {
                            // console.log(data, "ressserere")
                            const crrData = res?.data?.slice(0, 6)?.map(x => { x.id = res.id; x.category = res.category; return x });
                            return (
                                <>
                                    <div className="flex_grp_between mt-2 mb-3">
                                        <h3 className="section_title_light mb-0 flex1">{res?.id}</h3>
                                        {/* {console.log(res, "data.category")} */}
                                        {
                                            res?.data?.length > 6 && (
                                        <div onClick={() => res.category === "addons" ? navigate(`/addons-viewall/${res.webType}`, { state: res }) : navigate(`/bundles-viewall/${res.webType}`, { state: res })} className="hyperlink">
                                            {t("viewall")}
                                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                        </div>
                                            )
                                        }
                                    </div>
                                    <SwiperComponent type={4} data={crrData}></SwiperComponent>
                                </>
                            )
                        })}
                    </div>
                </Tab>}
            {data?.length > 0 ? data?.map((res, index) => {
                const crrData = res?.data?.slice(0, 6)?.map(x => { x.id = res.id; x.category = res.category; return x });
                return (
                    <Tab eventKey={res.id} title={res.id}>
                        {/* {console.log(data.category, "data.category")} */}
                        <div className='mt-5'>
                            <div className="flex_grp_between mt-2 mb-3">
                                {/* {console.log(res.id, "res.iddddd")} */}
                                <h3 className="section_title_light mb-0 flex1">{res?.id}</h3>
                                {
                                    res?.data?.length > 6 && (
                                <div onClick={() => res.category === "addons" ? navigate(`/addons-viewall/${res.webType}`, { state: res }) : navigate(`/bundles-viewall/${res.webType}`, { state: res })} className="hyperlink">
                                    {t("viewall")}
                                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                </div>
                                    )
                                }
                            </div>
                        </div>
                        <SwiperComponent type={4} data={crrData}></SwiperComponent>
                    </Tab>

                )
            }) : <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                {t('nodata')}
            </p>}
            {/* <Tab eventKey="all" title="All">
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Normal Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Prime Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                    </Tab> */}
            {/* tabs */}

        </Tabs> : <div className="xpress_no_trans text-center" >
            <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
            />
            <div className="mb-5">
                <label>{t("noofferptal")}</label>
            </div>
        </div>
        )

    }


    if (type === 2) {
        return <Tabs defaultActiveKey="all" transition={true} id="uncontrolled-tab-example" className="cs_tabs mb-3">
            <Tab eventKey="all" title={t('All')}>
                <ul className='account_list'>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                </ul>
            </Tab>
            <Tab eventKey="prepaid" title="Prepaid">
                <ul className='account_list'>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                </ul>
            </Tab>
            <Tab eventKey="postpaid" title="Postpaid">
                <ul className='account_list'>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                    <li className='flex_grp_between'>
                        <div className='profile_info_v1'>
                            <div className="profile_info_v1_img profile_info_img1 align-self-center">
                                <img src={process.env.PUBLIC_URL + '/assets/images/user.png'} alt="" title="" />
                            </div>
                            <div className="profile_info_v1_desc">
                                <div className='flex_grp_align_center'>
                                    <h3>Raffi</h3>
                                    <a href='#/edit-manage-lines' className='img_btn img_btn_md'>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/edit_red.svg'} alt="" title="" />
                                    </a>
                                </div>
                                <h4>66566122</h4>
                                <p>Shamel Voice</p>
                            </div>
                        </div>
                        <div className="cs_toggle_btn">
                            <input type="checkbox" name="toggle" id="test1"></input>
                            <label htmlFor="test1">&nbsp;</label>
                        </div>
                    </li>
                </ul>
            </Tab>
        </Tabs>
    }

    if (type === 3) {
        return <Tabs defaultActiveKey="all" transition={true} id="uncontrolled-tab-example" className="cs_tabs">
            <Tab eventKey="all" title={t('All')}>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
            </Tab>
            <Tab eventKey="africa-rates" title="Africa">
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
            </Tab>
            <Tab eventKey="Asia-rates" title="Asia">
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
                <CardsComponent type={13}></CardsComponent>
            </Tab>
        </Tabs>
    }

    if (type === 4) {

        return <Tabs defaultActiveKey="all" transition={true} id="uncontrolled-tab-example" className="cs_tabs">
            <Tab eventKey="all" title={t('All')}>
                {data?.category?.map((item, index) => (
                    <div>
                        <div className='mt-5 mb-3'>
                            <h6>{item?.name}</h6>
                        </div>
                        {data?.data?.find((item2, index) => item2?.id === item?.id)?.data?.map((item2, index) => <AccordionComponent type={5} data={item2}></AccordionComponent>)}
                    </div>
                ))}
            </Tab>
            {data?.category?.map((item, index) => (

                <Tab eventKey={item?.id} title={item?.name}>

                    {data?.data?.find((item2, index) => item2?.id === item?.id)?.data?.map((item2, index) => <AccordionComponent type={5} data={item2}></AccordionComponent>)}

                </Tab>

            ))}

        </Tabs>

    }

    if (type === 5) {
        //console.log(data, "datawrere")
        return ((data?.length > 0) ? <Tabs defaultActiveKey="all" transition={true} id="uncontrolled-tab-example" className="cs_tabs">
            <Tab eventKey="all" title={t('All')}>
                <div className='mt-5'>
                    {data.map(res => {
                        const crrData = res?.data.map(x => { x.id = res.id; x.psmItems = res.pmsitems; return x });

                        return (crrData?.map(response => {
                            return (
                                <AccordionComponent type={4} data={response}></AccordionComponent>

                            )
                        })
                        )
                    })}
                </div>
            </Tab>
            {data?.map(res => {
                const crrData = res?.data.map(x => { x.id = res.id; x.psmItems = res.pmsitems; return x });
                // console.log(crrData, "credsa")
                return (
                    <Tab key={res} eventKey={res?.id} title={res?.id}>
                        <div className='mt-5'>
                            {crrData?.map(response => {

                                return (
                                    <AccordionComponent type={4} data={response}></AccordionComponent>
                                )
                            })
                            }
                        </div>
                    </Tab>

                )
            })}
            {/* <Tab eventKey="africa-countries" title="Africa">
                <AccordionComponent type={2}></AccordionComponent>
                <AccordionComponent type={2}></AccordionComponent>
            </Tab>
            <Tab eventKey="asia-countries" title="Asia">
                <AccordionComponent type={2}></AccordionComponent>
                <AccordionComponent type={2}></AccordionComponent>
            </Tab> */}
        </Tabs> : <div className="xpress_no_trans text-center" >
            <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
            />
            <div className="mb-5">
                <label>{t("noofferptal")}</label>
            </div>
        </div>
        )
    }
    if (type === 6) {
        return <Tabs defaultActiveKey="roaming-rates" transition={true} id="uncontrolled-tab-example" tabClassName="demo" className="line_tabs">
            <Tab eventKey="roaming-rates" title={t("roamingrates")}>
                <div className='pse_sm pt-4 pb-4'>
                    <div className="icon_img_desc_style">
                        <div className="desc_grp">
                            <h4 className="primary_14 mb-0">{t("roamingservices")}</h4>
                            <p className="support_text mt-1 mb-0">{data && data.basicServices[0]?.description}</p>
                        </div>
                        <div className="action_grp">
                            <div className="cs_toggle_btn">
                                {data && <input type="checkbox" name="toggle" checked={roamingCheckBox} onChange={() => {
                                    setFlag("Roaming")
                                    toggleModal()
                                }} id="test6"></input>
                                }
                                <label htmlFor="test6">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <hr className='hr_line' />
                    <div className="icon_img_desc_style">
                        <div className="desc_grp">
                            <h4 className="primary_14 mb-0">{t("supportedoperators")} {data?.roamingRatesData?.country}</h4>
                            <p className="support_text mt-1 mb-0">{data?.roamingRatesData?.roaming?.map(res => {
                                return (
                                    <>
                                        {res?.rpname}, &nbsp;
                                    </>
                                )
                            })}</p>
                            <p className="font14 mt-1 mb-0 primary_color">{t("otherOperatorNotSupported")}</p>
                        </div>
                    </div>
                    <hr className='hr_line' />
                    <div className='flex_grp_between'>
                        <h4 className="primary_14 mb-0">{t("linternet")}</h4>
                        <p className='primary_color text-end font14 mb-0'><span dir='ltr'>{parseFloat(data?.roamingRatesData?.zones[0]?.GPRSperKB).toFixed(3)} KD/MB</span></p>
                    </div>
                    <hr className='hr_line' />
                    <div className='grp_info'>
                        <h4 className="primary_14 mb-3">{t("calls")}</h4>
                        <div className='flex_grp_between mb-2'>
                            <p className='font14 mb-0'>{t("received")}</p>
                            <p className='primary_color text-end font14 mb-0'><span dir='ltr'>{parseFloat(data?.roamingRatesData?.zones[0]?.IncomingCalls).toFixed(3)} KD/min</span></p>
                        </div>
                        <div className='flex_grp_between mb-2'>
                            <p className='font14 mb-0'>{t("tosamecountry")}</p>
                            <p className='primary_color text-end font14 mb-0'><span dir='ltr'>{parseFloat(data?.roamingRatesData?.zones[0]?.CallstosameCountry).toFixed(3)} KD/min</span></p>
                        </div>
                        <div className='flex_grp_between mb-2'>
                            <p className='font14 mb-0'>{t("backtokuwait")}</p>
                            <p className='primary_color text-end font14 mb-0'><span dir='ltr'>{parseFloat(data?.roamingRatesData?.zones[0]?.CallstoKuwait).toFixed(3)} KD/min</span></p>
                        </div>
                        <div className='flex_grp_between mb-2'>
                            <p className='font14 mb-0'>{t("toanothercountry")}</p>
                            <p className='primary_color text-end font14 mb-0'><span dir='ltr'>{parseFloat(data?.roamingRatesData?.zones[0]?.Restoftheworld).toFixed(3)} KD/min</span></p>
                        </div>
                    </div>
                    <hr className='hr_line' />
                    <div className='grp_info'>
                        <h4 className="primary_14 mb-3">{t("sms")?.toUpperCase()}</h4>
                        <div className='flex_grp_between mb-2'>
                            <p className='font14 mb-0'>{t("sending")}</p>
                            <p className='primary_color text-end font14 mb-0'><span dir='ltr'>{parseFloat(data?.roamingRatesData?.zones[0]?.SendingSMS).toFixed(3)} KD/sms</span></p>
                        </div>
                        <div className='flex_grp_between mb-2'>
                            <p className='font14 mb-0'>{t("received")}</p>
                            <p className='primary_color text-end font14 mb-0'><span dir='ltr'>0.000 KD/sms</span></p>
                        </div>
                    </div>
                    <hr className='hr_line' />
                    <div class="text-center">
                        <p className='font14 text-center mb-4'>{t("payasyougo")}</p>
                        {!isViewPacks && <button class="custom_btn custom_btn_primary_outline btn_block" onClick={() => navigate('/passportmulticountry')}>{t("buyOoredooPassport")}</button>}
                    </div>
                    {isViewPacks && <div>
                        <Swiper
                            className="swiper-wrapper"
                            spaceBetween={12}
                            slidesPerView={1}
                            pagination={{
                                clickable: true
                            }}
                            modules={[Grid, Pagination]}
                        >
                            {data?.roamingRatesData?.roamingimage?.images?.map((item)=> {
                            return(
                                <SwiperSlide>
                                    <section class="section-bg" >
                                        <div class="sprint14-offer-comp">
                                            <h4>{item?.title}</h4>
                                            <div>
                                                <div class="print14-offer-bg">
                                                <img src={data?.roamingRatesData?.roamingimage?.backgroundimage}  alt="" title=""/>
                                                </div>
                                                <div class="w-100 might-you-like-comp" >
                                                    <img src={item?.path} alt="" title="" className='w-100' onClick={()=> redirecturl(item?.url, navigate)}/>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </SwiperSlide>
                            )})}
                        </Swiper>
                    </div>
                    }
                </div>
                {data && flag === "Roaming" && <BottomModal1Component roaming={roamingCheckBox} check={setroamingCheckBox} show={showModal} id={data?.basicServices[0]?.serviceid} toggleModal={toggleModal} data={data?.basicServices[0]?.popup} basicrefetch={data?.basicRefetch} status={data?.basicServices[0]?.status === "A"} />}
            </Tab>
            {/* {console.log(data.basicServices[1].status === "A", "data.basicServices[0].status")} */}
            <Tab eventKey="call-rates" title={t("intCallRates")}>
                <div className='pse_sm pt-4 pb-4'>
                    <div className="icon_img_desc_style">
                        <div className="desc_grp">
                            <h4 className="primary_14 mb-0">{t('internationalCalls')}</h4>
                            <p className="support_text mt-1 mb-0">{data && data?.basicServices[1]?.description}</p>
                        </div>
                        <div className="action_grp">
                            <div className="cs_toggle_btn">
                                {data && <input type="checkbox" name="toggle" checked={callsCheckBox} onChange={() => {
                                    setFlag("Call")
                                    toggleModal()
                                }} id="test7"></input>}
                                <label htmlFor="test7">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <hr className='hr_line' />
                    <h4 className="primary_14 mb-3">{t("fromKuwaitTo")} {data?.roamingRatesData?.country} </h4>
                    <div className='flex_grp_between'>
                        <h4 className="primary_14 mb-0">{t("calls")}</h4>
                        {data && <p className='primary_color text-end font14 mb-0' dir='ltr'>{customerprofile?.RatePlanType === "PREPAID" ? parseFloat(data?.roamingRatesData?.roaming[0]?.prepaidrates).toFixed(3) : parseFloat(data?.roamingRatesData?.roaming[0]?.postpaidrates).toFixed(3)} {t("KD/min")}</p>}
                    </div>
                    <hr className='hr_line' />
                    <div className='flex_grp_between'>
                        <h4 className="primary_14 mb-0">{t("sms")}</h4>
                        <p className='primary_color text-end font14 mb-0' dir='ltr'>{customerprofile?.RatePlanType === "PREPAID" ? parseFloat(data?.roamingRatesData?.roaming[0]?.SMS_Prepaid).toFixed(3) : parseFloat(data?.roamingRatesData?.roaming[0]?.SMS_Postpaid).toFixed(3)} {t("KD/sms")}</p>
                    </div>
                    <hr className='hr_line' />
                    <div class="text-center">
                        <p className='font14 text-center mb-4'>{t("payasyougo")}</p>
                        {!isViewPacks && <button class="custom_btn custom_btn_primary_outline btn_block" onClick={() => navigate('/passportmulticountry')}>{t("buyOoredooPassport")}</button>}
                    </div>
                    {isViewPacks && <div>
                        <Swiper
                            className="dashboard_swiper"
                            spaceBetween={12}
                            slidesPerView={1}
                            pagination={{
                                clickable: true
                            }}
                        >
                            {data?.roamingRatesData?.internationalimage?.images?.map((item)=> {
                            return(
                                <SwiperSlide>
                                    <section class="section-bg" >
                                        <div class="sprint14-offer-comp">
                                            <h4>{item?.title}</h4>
                                            <div>
                                                <div class="print14-offer-bg">
                                                <img src={data?.roamingRatesData?.internationalimage?.backgroundimage}  alt="" title=""/>
                                                </div>
                                                <div class="w-100 might-you-like-comp" >
                                                    <img src={item?.path} alt="" title="" className='w-100' onClick={()=> redirecturl(item?.url, navigate)}/>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </SwiperSlide>
                            )})}
                        </Swiper>
                    </div>}
                </div>
                {data && flag === "Call" && <BottomModal1Component show={showModal} roaming={callsCheckBox} check={setCallsCheckBox} id={data.basicServices[1].serviceid} toggleModal={toggleModal} data={data.basicServices[1].popup} basicrefetch={data?.basicRefetch} status={data.basicServices[1].status === "A"} />}
            </Tab>

        </Tabs>


    }
    if (type === 7) {
        return <Tabs defaultActiveKey="all" transition={true} id="uncontrolled-tab-example" className="cs_tabs m-0">
            <Tab eventKey="all" title={t('All')}>
                <div className='mt-5'>
                    {data?.map(res => {
                        return (
                            res?.data?.map(response => {
                                return (
                                    <AccordionComponent key={response} type={2} data={response}></AccordionComponent>
                                )
                            })
                        )
                    })}
                </div>
                {/* <AccordionComponent type={2}></AccordionComponent>
                        <AccordionComponent type={2}></AccordionComponent>
                        <AccordionComponent type={2}></AccordionComponent>
                        <AccordionComponent type={2}></AccordionComponent> */}
            </Tab>
            {data?.map(res => {
                // console.log(res, "responsesse")
                return (
                    <Tab key={res} eventKey={res?.id} title={res?.id}>
                        <div className='mt-5'>
                            {res?.data?.map(response => {

                                return (

                                    <AccordionComponent type={2} data={response}></AccordionComponent>

                                )
                            })
                            }
                        </div>
                    </Tab>

                )
            })}

            {/* <Tab eventKey="asia-countries" title="Asia">
                <AccordionComponent type={2}></AccordionComponent>
                <AccordionComponent type={2}></AccordionComponent>
            </Tab> */}
        </Tabs >
    }
    if (type === 8) {
        if(data?.data?.length === 0 || data?.data === undefined){
            return <NoData message ={data?.message}/>
        }else{
            return <Tabs defaultActiveKey="All" transition={true} id="uncontrolled-tab-example" className="cs_tabs">
                <Tab eventKey="All" title={t('All')}>
                    {data?.category?.filter(item => item.type === "category")?.map((item, index) => (
                        <div>
                            <div className='mt-3 mb-3'>
                                <h6 style={{ "direction": language === "ar" ? "ltr" : "", textAlign:  language === "ar"  ? "end": "" }}>{item?.name} </h6>
                            </div>
                            <SwiperComponent categoryId={item?.id} categoryId_ar={item?.id_ar} categoryId_en={item?.id_en} psmItem={data?.psmItem} type={11} data={data?.data?.find((item2, index) => item2?.id === item?.id)?.data?.map((item2, index) => item2)} bgColor={data?.bgColor}></SwiperComponent>
                        </div>
                    ))}
                </Tab>
                {data?.category?.map((item, index) => {
                    const offerData = item.type === "offerid" ? [].concat(...data?.data?.map(subitem => subitem?.data?.filter(subitem2 => subitem2.offerid === item.id))?.filter(subitem3 => subitem3?.length)) : []
                    const tabData = <Tab eventKey={item?.id} title={<span style={{direction: isContainAlphabet(item?.name) ? "ltr" : ""}}>{item?.name}</span>}>
                        <div className='mt-3 mb-3 d-flex justify-content-between'>
                            {data?.data?.length > 0 ? <h6>{item?.name}</h6> : null}
                            {data?.data?.length > 6 &&
                                <Link to="/" className="hyperlink">
                                    {t("viewall")}
                                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                </Link>}
                        </div>
                        <SwiperComponent categoryId={item?.id} categoryId_ar={item?.id_ar} categoryId_en={item?.id_en} psmItem={data?.psmItem} type={11} data={item.type === "offerid" ? offerData : data?.data?.find((item2, index) => item2?.id === item?.id)?.data?.map((item2, index) => item2)} bgColor={data?.bgColor}></SwiperComponent>

                    </Tab>
                    return item.type === "offerid" ? offerData?.length ? tabData : null : tabData
                }

            )}

        </Tabs>}

    }

    if (type === 9) {
        // console.log("tab data&&&&&&&&&&&&&&&&&&&&:"+JSON.stringify(data))
        // console.log(data, "datadatadata")

        const handleViewAll = (res) => {
            if(metaData?.web_notallowed === "true"){
                setDisplayText('digitalservices')
                setShow(true);

                return;
            }else{
                navigate(`/digitalservices-viewall/${res.id}`, { state: {result: res, flag: metaData?.web_notallowed} })
            }
        }

        return ((data?.length > 0) ? <><Tabs  activeKey={(data?.length === 1) ? data[0]?.id : key}
        onSelect={(k) => setKey(k)}  transition={true} id="uncontrolled-tab-example"
            className="cs_tabs">
            {/* All */}
            {/* {console.log(filteredCategory, "filteredCategoryfilteredCategory")} */}
            {/* {console.log("categories:"+JSON.stringify(categories)+"")} */}

            {((state !== null && state?.length === 0 || state?.length > 1) && data?.length > 1) &&
                <Tab eventKey="all" title={t('All')}>
                    <div className='mt-5'>
                        {data?.length > 0 ? data?.map(res => {
                            // { console.log(JSON.stringify(data), "datadatadatadatadatadata") }
                            const crrData = res?.data.map(x => { x.id = res.id; x.category = res.category; return x });
                            return (
                                <>
                                    <div className="flex_grp_between mt-2 mb-3">
                                        {/* <h3 className="section_title_light mb-0 flex1">{res?.id}</h3> */}
                                        {
                                            categories?.filter(t => t?.id === res?.id)?.map(cat => {
                                                return (<>
                                                    <h3 className="section_title_light mb-0 flex1">{cat?.name}</h3>
                                                </>)
                                            })
                                        }
                                        <div onClick={() => {
                                            // navigate(`/digitalservices-viewall/${res.id}`, { state: {result: res, flag: metaData?.web_notallowed} })

                                            handleViewAll(res);
                                        }
                                        } className="hyperlink">
                                            {t("viewall")}
                                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                        </div>
                                    </div>
                                    <SwiperComponent type={12} data={crrData} flag={metaData?.web_notallowed}></SwiperComponent>
                                </>
                            )
                        }) : <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                            {t('nodata')}
                        </p>}
                    </div>
                </Tab>
            }
            {
                data?.length > 0 ? data?.map((res, index) => {
                    //console.log("responsessssss:"+JSON.stringify(res[index]))
                    const crrData = res?.data.map(x => { x.id = res.id; x.category = res.category; return x });
                    return (
                        <Tab key={res.id} eventKey={res.id} 
                        title={categories?.filter(t => t?.id === res?.id)?.map(x => (x.name))}>
                            <div className='mt-5'>
                                <div className="flex_grp_between mt-2 mb-3">

                                    {/* <h3 className="section_title_light mb-0 flex1">{res?.id}</h3> */}
                                    {
                                        categories?.filter(t => t?.id === res?.id)?.map(cat => {
                                            return (<>
                                                <h3 className="section_title_light mb-0 flex1">{cat?.name}</h3>
                                            </>)
                                        })
                                    }

                                    <div onClick={() =>{ 
                                        // navigate(`/digitalservices-viewall/${res.id}`, { state: res })

                                        handleViewAll(res);
                                    }
                                    } className="hyperlink">
                                        {t("viewall")}
                                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                    </div>
                                </div>
                            </div>
                            <SwiperComponent type={12} data={crrData}></SwiperComponent>
                        </Tab>

                    )
                }) : <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    {t('nodata')}
                </p>
            }
            {/* <Tab eventKey="all" title="All">
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Normal Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Prime Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                    </Tab> */}
            {/* tabs */}
        </Tabs >
        
        <ExclusiveModal
            show={show}
            toggleModal={()=> setShow(!show)}
            deeplinktext={displaytext}
        />

        </> : (
            <div className="xpress_no_trans text-center" >
            <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
            />
            <div className="mb-5">
                <label>{t("noofferptal")}</label>
            </div>
        </div>
        ))

    }
    //ooredeo rwards
    if (type === 10) {
        try{
        console.log(data, "datasss")
        console.log(categories, "categoriessss")
        }catch{}
        return ((data?.length > 0) ? <Tabs  activeKey={(data?.length === 1) ? data[0]?.id : key}
        onSelect={(k) => setKey(k)} transition={true} id="uncontrolled-tab-example" className="cs_tabs">
            {/* All */}
            {/* {console.log(filteredCategory, "filteredCategoryfilteredCategory")} */}
            {((state !== null && state?.length === 0 || state?.length > 1) && data?.length > 1) &&
                <Tab eventKey="all" title={t('All')}>
                    <div className='mt-5'>
                        {data?.map(res => {
                            // console.log(data, "ressserere")
                            let ctgIds = "";
                            try{
                                const catgs = categories?.filter(item => item.id === res.id)?.map((item, index) => {
                                    console.log("catgs en->:"+item?.id_en+",catgs ar->:"+item?.id_ar+"")
                                    ctgIds = item?.id_en+"|"+item?.id_ar;
                                })
                            }catch{}

                            const crrData = res?.data.slice(0, 6).map(x => { 
                                if(x.category = res.id){
                                    return {...x, category: ctgIds}
                                } 
                                });
                            
                            { console.log(data, "ressss") }
                            return (
                                <>
                                    <div className="flex_grp_between mt-2 mb-3">
                                        <h3 className="section_title_light mb-0 flex1">{res?.id}</h3>
                                        {/* {console.log(res, "data.category")} */}
                                        <div onClick={() => navigate(`/ooredeorewards-viewall/${ctgIds}`, { state: res?.phoneNumber?.giftnumber !== undefined ? res?.phoneNumber?.giftnumber : res?.phoneNumber  })} className="hyperlink">
                                            {t("viewall")}
                                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                        </div>
                                    </div>
                                    <SwiperComponent type={17} data={crrData} giftnumber={giftnumber}></SwiperComponent>
                                </>
                            )
                        })}
                    </div>
                </Tab>}
            {data?.length > 0 ? data?.map((res, index) => {

let ctgIds = "";
try{
    const catgs = categories?.filter(item => item.id === res.id)?.map((item, index) => {
        console.log("catgs en->:"+item?.id_en+",catgs ar->:"+item?.id_ar+"")
        ctgIds = item?.id_en+"|"+item?.id_ar;
    })
}catch{}

const crrData = res?.data.slice(0, 6).map(x => { 
    if(x.category = res.id){
        return {...x, category: ctgIds}
    } 
    });
                return (
                    <Tab key={res.id} eventKey={res.id} title={res.id}>
                        {/* {console.log(data.category, "data.category")} */}
                        <div className='mt-5'>
                            <div className="flex_grp_between mt-2 mb-3">
                                {/* {console.log(res.id, "res.iddddd")} */}
                                <h3 className="section_title_light mb-0 flex1">{res?.id}</h3>
                                <div onClick={() => navigate(`/ooredeorewards-viewall/${ctgIds}`, { state: res?.phoneNumber?.giftnumber !== undefined ? res?.phoneNumber?.giftnumber : res?.phoneNumber  })} className="hyperlink">
                                    {t("viewall")}
                                    <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                </div>
                            </div>
                        </div>
                        <SwiperComponent type={17} data={crrData} giftnumber={giftnumber}></SwiperComponent>
                    </Tab>

                )
            }) : <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                {t('nodata')}
            </p>}
            {/* <Tab eventKey="all" title="All">
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Normal Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Prime Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                    </Tab> */}
            {/* tabs */}

        </Tabs> : <div className="xpress_no_trans text-center pt-4" >
            <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
            />
            <div className="mb-5">
                <label>
                    { isNoFilterItem ? t('wcf') : t("nooffersmsg") }
                </label>
            </div>
        </div>
        )

    }
    // Transfer Poitns
    if (type === 11) {
        return ((data?.length > 0) ? <Tabs defaultActiveKey={'all'} transition={true} id="uncontrolled-tab-example" className="cs_tabs">
            {/* All */}
            {/* {console.log(filteredCategory, "filteredCategoryfilteredCategory")} */}
            {(state !== null && state?.length === 0 || state?.length > 1) &&
                <Tab eventKey="all" title={t('All')}>
                    <div className='mt-5'>
                        {data?.map(res => {
                            // console.log(data, "ressserere")
                            const crrData = res?.data.slice(0, 6).map(x => {
                                // console.log('x==>', x);
                                const temp = JSON.parse(JSON.stringify(x));
                                temp.category = res.id;
                                return temp;
                            });
                            // { console.log(data, "ressss") }
                            // { console.log("crrData==>", crrData) }
                            return (
                                <>
                                    <div className="flex_grp_between mt-2 mb-3">
                                        {/* <h3 className="section_title_light mb-0 flex1">{res?.id}</h3> */}
                                        {/* {console.log(res, "data.category")} */}
                                        {
                                            categories?.filter(t => t?.id === res?.id)?.map(cat => {
                                                return (<>
                                                    <h3 className="section_title_light mb-0 flex1">{cat?.name}</h3>
                                                </>)
                                            })
                                        }


                                    </div>
                                    <SwiperComponent type={19} data={crrData}></SwiperComponent>
                                </>
                            )
                        })}
                    </div>
                </Tab>}
            {data?.length > 0 ? data?.map((res, index) => {
                const crrData = res?.data.map(x => { x.category = res.id; return x });
                return (
                    <Tab key={res.id} eventKey={res.id}
                        title={categories?.filter(t => t?.id === res?.id)?.map(x => (x.name))}>
                        {/* {console.log(data.category, "data.category")} */}
                        <div className='mt-5'>
                            <div className="flex_grp_between mt-2 mb-3">
                                {/* {console.log(res.id, "res.iddddd")} */}
                                {/* <h3 className="section_title_light mb-0 flex1">{res?.id}</h3> */}
                                {
                                    categories?.filter(t => t?.id === res?.id)?.map(cat => {
                                        return (<>
                                            <h3 className="section_title_light mb-0 flex1">{cat?.name}</h3>
                                        </>)
                                    })
                                }

                            </div>
                        </div>
                        <SwiperComponent type={19} data={crrData}></SwiperComponent>
                    </Tab>

                )
            }) : <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                {t('nodata')}
            </p>}
            {/* <Tab eventKey="all" title="All">
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Normal Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                        <div className="flex_grp_between mt-2 mb-3">
                            <h3 className="section_title_light mb-0 flex1">Prime Bundles</h3>
                            <a className="hyperlink">
                                viewall
                                <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                            </a>
                        </div>
                        <SwiperComponent type={4}></SwiperComponent>
                    </Tab> */}
            {/* tabs */}

        </Tabs> : <div className="xpress_no_trans text-center pt-4" >
            <img
                     src={process.env.PUBLIC_URL + '/assets/images/searchcloud.jpg'}
                alt=""
                title=""
            />
            <div className="mb-5">
            <label>{t("wcf")}</label>
            </div>
        </div>
        )

    }
    //Transfer Credit
    if (type === 12) {
        return <Tabs defaultActiveKey="ooredeo-number" transition={true} id="uncontrolled-tab-example" tabClassName="demo" className="line_tabs">
            <Tab eventKey="ooredeo-number" title={t("Ooredeo Number")}>
                <TransferCreditPay />
            </Tab>
            {/* {console.log(data.basicServices[1].status === "A", "data.basicServices[0].status")} */}
            <Tab eventKey="international" title={t("International")}>

            </Tab>

        </Tabs>


    }


     // Recent - Tramsactopms
     if (type === 13) {
        return ((data?.length > 0) ? 
        <Tabs activeKey={(data?.length === 1) ? data[0]?.id : key}
        onSelect={(k) => setKey(k)}  transition={true} id="uncontrolled-tab-example" 
        className="cs_tabs">
            {((state !== null && state?.length === 0 || state?.length > 1) && data?.length > 1) &&
                <Tab eventKey="all" title={t('All')}>
                    <div className='mt-5'>
                        {data?.map((res,index) => {
                   
                            const crrData = res?.data.slice(0, 4).map(x => { x.id = res.id; x.category = res.category; return x })
                            return (
                                <>
                                    <div className="flex_grp_between mt-2 mb-3">
                                        {/* <h3 className="section_title_light mb-0 flex1">{categories[index].name}</h3>
                                       */}
                                        {
                                            categories?.filter(t => t?.id === res?.id)?.map(cat => {
                                                return (<>
                                                    <h3 className="section_title_light mb-0 flex1">{cat?.name}</h3>
                                                </>)
                                            })
                                        }
                                      
                                       {res?.data?.length > 4  && <div onClick={() =>  navigate(`/recent-Transaction-Viewall/${res.id}`, { state: res })} className="hyperlink">
                                       {t("viewall")}
                                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                        </div>}
                                    </div>
                                    <SwiperComponent type={4} data={crrData}></SwiperComponent>
                                </>
                            )
                        })}
                    </div>
                </Tab>}
            {data?.length > 0 ? data?.map((res, index) => {
                   const crrData = res?.data.slice(0, 4).map(x => { x.id = res.id; x.category = res.category; return x }) 
                return (
                    <Tab key={res.id} eventKey={res.id} 
                    
                   title={categories?.filter(t => t?.id === res?.id)?.map(x => (x.name))}
                    //title={categories[index].name}
                    >
                        {/* {console.log(data.category, "data.category")} */}
                        <div className='mt-5'>
                            <div className="flex_grp_between mt-2 mb-3">
                                {/* {console.log(res.id, "res.iddddd")} */}
                                {/* <h3 className="section_title_light mb-0 flex1">{categories[index].name}</h3> */}

                                {
                                        categories?.filter(t => t?.id === res?.id)?.map(cat => {
                                            return (<>
                                                <h3 className="section_title_light mb-0 flex1">{cat?.name}</h3>
                                            </>)
                                        })
                                    }





                                {res?.data?.length > 4  &&  <div onClick={() => navigate(`/recent-Transaction-Viewall/${res.id}`, { state: res }) } className="hyperlink">
                                       {t("viewall")}     
                                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                                        </div>}
                            </div>
                        </div>
                        <SwiperComponent type={4} data={crrData}></SwiperComponent>
                    </Tab>

                )
            }) : <p style={{ textAlign: 'center', marginBottom: '2rem' }}>
                {t('nodata')}
            </p>}
        </Tabs> : <div className="xpress_no_trans text-center" >
            <img
                src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
                alt=""
                title=""
            />
            <div className="mb-5">
                <label>{t("noofferptal")}</label>
            </div>
        </div>
        )

    }
    if (type === 14) {

        return <Tabs defaultActiveKey="roaming-rates" transition={true} 
        id="uncontrolled-tab-example" tabClassName="demo" className="line_tabs white_bg sprint14_roaming_tabs">
          <Tab eventKey="roaming-rates" title={t("roamingrates")}>
                <div className='pse_sm pt-4 pb-4'>
                    <div>
                    <div className="icon_img_desc_style">
                        <div className="desc_grp">
                            {/* <h4 className="primary_14 mb-0">{data?.roaming[0]?.category}</h4> */}
                            <h4 className="primary_20 mb-0 rubik-semiBold">{data?.roaming[0]?.name}</h4>
                           
                        </div>
                        <div className="action_grp">
                            <div className="cs_toggle_btn">
                                {data && <input type="checkbox" name="toggle" checked={roaming_CheckBox} onChange={() => {
                                    setFlag("Roaming")
                                    toggleModal()
                                }} id="test6"></input>
                                }
                                <label htmlFor="test6">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <p className="support_text mt-3 mb-3 primary1_16 notoSans-light">{data && data?.roaming[0]?.description}</p>
                    </div>
                   
                    <hr className='hr_line' />
                    <div className="icon_img_desc_style">
                        <div className="desc_grp">
                            <h4 className="primary_12 mb-0 rubik-semiBold">{t("supportedoperators")?.toUpperCase()} {data?.roamingRatesData?.country?.toUpperCase()}</h4>
                            <p className="primary_13 support_text mt-3 mb-0 notoSans-light">{data?.roamingRatesData?.roaming?.map(res => {
                                return (
                                    <>
                                        {res?.rpname}, &nbsp;
                                    </>
                                )
                            })}</p>
                            <p className="primary_13 mt-3 mb-0 primary_color rubik-semiBold">{t("otherOperatorNotSupported")?.toUpperCase()}</p>
                        </div>
                    </div>
                    <hr className='hr_line' />
                    
                    <div class="mb-4">
                        <div class="white-bg sprint14-roaming-charges borderradius15">

                            <div class="roamingpackrow">
                                <div class="roaming-pack-row">
                                    <div class="roaming-sub-left"> {t("linternet")} </div>
                                    <div class="roaming-sub-right"> <label className='dir-ltrl'>{parseFloat(data?.roamingRatesData?.zones[0]?.GPRSperKB)?.toFixed(3)} KD/MB </label>
                                    </div>
                                </div>

                                <hr/>

                                <div class="roaming-pack-row pb-2">
                                    <div class="roaming-sub-left">{t("calls")} </div>
                                    
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-pack-text">{t("received")}</div>
                                    <label className='dir-ltrl'>{parseFloat(data?.roamingRatesData?.zones[0]?.IncomingCalls)?.toFixed(3)} KD/min </label>
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-pack-text"> {t("tosamecountry")} </div>
                                    <label className='dir-ltrl'> {parseFloat(data?.roamingRatesData?.zones[0]?.CallstosameCountry)?.toFixed(3)} KD/min </label>
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-pack-text"> {t("backtokuwait")} </div>
                                    <label className='dir-ltrl'> {parseFloat(data?.roamingRatesData?.zones[0]?.CallstoKuwait)?.toFixed(3)} KD/min </label>
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-pack-text"> {t("toanothercountry")} </div>
                                    <label className='dir-ltrl'> {parseFloat(data?.roamingRatesData?.zones[0]?.Restoftheworld)?.toFixed(3)} KD/min </label>
                                </div>
                            </div>

                            <hr/>

                            <div class="roamingpackrow">
                                <div class="roaming-pack-row pb-2">
                                    <div class="roaming-sub-left"> {t("sms")?.toUpperCase()}</div>
                                    
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-pack-text"> {t("sending")} </div>
                                    <label className='dir-ltrl'>{parseFloat(data?.roamingRatesData?.zones[0]?.SendingSMS)?.toFixed(3)} KD/sms</label>
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-pack-text"> {t("received")} </div>
                                    <label className='dir-ltrl'> 0.000 KD/sms </label>
                                </div>
                            </div>

                            <hr/>

                            <div class="roaming-noraml-text">
                                {getGlobalSettingValue('payasyougotextnotsupported', settingsArr) || t("payasyougo")}
                            </div>

                        </div>
                    </div>

                        
                </div>
                <section >
                            <div class="sprint14-offer-comp">
                                {/* <h4>{data?.roamingRatesData?.roamingimage?.title}</h4> */}
                                <h4>{t('umaylike')}</h4>
                                <div>
                                    <div class="print14-offer-bg">
                                    <img src={data?.roamingRatesData?.roamingimage?.backgroundimage}  alt="" title=""/>
                                    </div>
                                    <div class="w-100 might-you-like-comp" >
                                        <img src={data?.roamingRatesData?.roamingimage?.images[0]?.path} alt="" title="" className='w-100' onClick={()=> redirecturl(data?.roamingRatesData?.roamingimage?.images[0]?.url, navigate, null, null, null,null, true)}/>
                                    </div>
                                </div>
                            </div>
                        </section>
                {data && flag === "Roaming" && <BottomModalRoamingInterRates roaming={roaming_CheckBox} check={setroaming_CheckBox} show={showModal} id={data?.roaming[0]?.serviceid} toggleModal={toggleModal} data={data?.roaming[0]?.popup} basicrefetch={data?.basicRefetch} status={data?.roaming[0]?.status === "A"} />}
            </Tab>
          
            
            <Tab eventKey="call-rates" title={t("intCallRates")}>
                <div className='pse_sm pt-4 pb-4'>
                    <div>
                    <div className="icon_img_desc_style">
                        <div className="desc_grp">
                            <h4 className="primary_20 mb-0 rubik-semiBold mb-0">{t('internationalCalls')}</h4>
                           
                        </div>
                        <div className="action_grp">
                            <div className="cs_toggle_btn">
                                {data && <input type="checkbox" name="toggle" checked={calls_CheckBox} onChange={() => {
                                    setFlag("Call")
                                    toggleModal()
                                }} id="test7"></input>}
                                <label htmlFor="test7">&nbsp;</label>
                            </div>
                        </div>
                    </div>
                    <p className="primary1_16 mt-3 mb-0 notoSans-light">{data && data?.international[0]?.description}</p>
                    </div>
                  
                    <hr className='hr_line' />


                    <div>
                        <div class="sprint14cardhed">
                            <div class="primary_12 rubik-semiBold">
                            {t("fromKuwaitTo")?.toUpperCase()} {data?.roamingRatesData?.country?.toUpperCase()}
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="white-bg sprint14-roaming-charges borderradius15">
                            <div class="roamingpackrow">
                                <div class="roaming-pack-row">
                                    <div class="roaming-sub-left"> {t("calls")} </div>
                                    <div class="roaming-sub-right"> <label className='dir-ltrl'> {customerprofile.RatePlanType === "PREPAID" ? parseFloat(data?.roamingRatesData?.roaming[0]?.prepaidrates)?.toFixed(3) : parseFloat(data?.roamingRatesData?.roaming[0]?.postpaidrates)?.toFixed(3)} {t("KD/min")}</label>
                                    </div>
                                </div>
                                <div class="roaming-pack-row">
                                    <div class="roaming-sub-left"> {t("sms")?.toUpperCase()}</div>
                                    <div class="roaming-sub-right"> <label className='dir-ltrl'> {customerprofile.RatePlanType === "PREPAID" ? parseFloat(data?.roamingRatesData?.roaming[0]?.SMS_Prepaid)?.toFixed(3) : parseFloat(data?.roamingRatesData?.roaming[0]?.SMS_Postpaid)?.toFixed(3)} {t("KD/sms")} </label>
                                    </div>
                                </div>
                            </div>
                            {/* <hr/>

                            <div class="roaming-noraml-text">
                                {t("payasyougo")}
                            </div> */}


                        </div>
                    </div>
                </div>
                <section >
                        <div class="sprint14-offer-comp">
                            <h4>{data?.roamingRatesData?.roamingimage?.title}</h4>
                            <div>
                                <div class="print14-offer-bg">
                                <img src={data?.roamingRatesData?.internationalimage?.backgroundimage}  alt="" title=""/>
                                </div>
                                <div class="w-100 might-you-like-comp" >
                                    <img src={data?.roamingRatesData?.internationalimage?.images[0]?.path} alt="" title="" className='w-100' onClick={()=> redirecturl(data?.roamingRatesData?.internationalimage?.images[0]?.url, navigate, null, null, null, null, true)}/>
                                </div>
                            </div>
                        </div>
                    </section>
                {data && flag === "Call" && <BottomModalRoamingInterRates show={showModal} roaming={calls_CheckBox} check={setCalls_CheckBox} id={data?.international[0]?.serviceid} toggleModal={toggleModal} data={data?.international[0]?.popup} basicrefetch={data?.basicRefetch} status={data?.international[0]?.status === "A"} />}
            </Tab>
        </Tabs>


    }
    // 4 to 15
    if (type === 15) {

        return <Tabs defaultActiveKey="all" transition={true} id="uncontrolled-tab-example" className="cs_tabs mb-5 m-0">
        <Tab eventKey="all" title={t('All')}>
            {data?.category?.map((item, index) => (
                <div>
                    {data?.data?.find((item2, index) => item2?.id === item?.id)?.data?.map((item2, index) => <AccordionComponent type={8} data={item2}></AccordionComponent>)}
                </div>
            ))}
        </Tab>
        {data?.category?.map((item, index) => (

            <Tab eventKey={item?.id} title={item?.name}>

                {data?.data?.find((item2, index) => item2?.id === item?.id)?.data?.map((item2, index) => <AccordionComponent type={8} data={item2}></AccordionComponent>)}

            </Tab>

        ))}

    </Tabs>

    }

}
export default TabsComponent;